import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getMopOnFileSuccess, getMopOnFileFailure, setEditableMop, setSelectedMop, prependMopToList, updateMopList, isLoadingMopOnFile, setYifteeMop, venmoInitialize } from './MopOnFileState.actions';
import { createReducer } from '@reduxjs/toolkit';
export var initialState = {
  errors: null,
  paymentMethods: [],
  isLoadingMops: false,
  hasLoadedMops: false,
  selectedMop: {},
  // the currently displayed mop in the mopOnFile dropdown
  editableMop: null,
  // the mop that is currently being edited
  yifteeMop: null,
  venmo: null
};
var reducer = createReducer(initialState, function (builder) {
  builder.addCase(setSelectedMop, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedMop: action.payload.mop
    });
  }).addCase(getMopOnFileSuccess, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      errors: action.payload.errors,
      paymentMethods: action.payload.data,
      hasLoadedMops: true,
      isLoadingMops: false
    });
  }).addCase(getMopOnFileFailure, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      errors: action.payload.errors,
      hasLoadedMops: true,
      isLoadingMops: false
    });
  }).addCase(prependMopToList, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      paymentMethods: [action.payload.mop].concat(_toConsumableArray(state.paymentMethods)),
      selectedMop: action.payload.mop
    });
  }).addCase(updateMopList, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      paymentMethods: action.payload.paymentMethods
    });
  }).addCase(isLoadingMopOnFile, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadingMops: action.payload.isLoadingMops
    });
  }).addCase(setEditableMop, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      editableMop: action.payload.mop
    });
  }).addCase(setYifteeMop, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      yifteeMop: action.payload.mop
    });
  }).addCase(venmoInitialize, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      venmo: _objectSpread(_objectSpread({}, state.venmo), action.payload)
    });
  });
});
export default reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/MopOnFileState/MopOnFileState.reducer.js
// module id = 4531
// module chunks = 11